import React, { useState, useCallback } from 'react'
import styled from 'styled-components'
import Sidebar from 'components/Sidebar'
import Topbar from 'components/Topbar'

const Dashboard = ({ children }) => {
  let [showSidebar, setShowSidebar] = useState(true)

  const updateSidebar = useCallback(value => {
    if (value === undefined) setShowSidebar(!showSidebar)
  })

  return (
    <>
      <Container>
        <Sidebar showSidebar={showSidebar} updateSidebar={updateSidebar} />
        <MainSection>
          <Topbar showSidebar={showSidebar} updateSidebar={updateSidebar} />
          <Content>{children}</Content>
        </MainSection>
      </Container>
    </>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100vh;
  max-height: 100vh;
  overflow: hidden;
`

const MainSection = styled.div`
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
`

const Content = styled.div`
  padding: 12px;
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100% - 80px);
`

export default Dashboard
